// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ElementWrapper_wrapper__1hBoA","title":"ElementWrapper_title__7EhZf","icon":"ElementWrapper_icon__1h1tb","open":"ElementWrapper_open__Owmr3"};